<template>
    <div id="app">
        <Main/>
    </div>
</template>

<script>
    import Main from '@/views/Main.vue'
    import Cookies from 'js-cookie'

    export default {
        name: 'app',
        components: {
            Main
        },
        created() {
            // eslint-disable-next-line
            console.log('api:', process.env.VUE_APP_API)
            Cookies.remove('wxLoginInfo') //重置微信授权状态
        }
    }
</script>

<style>
    #app {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        /*text-align: center;*/
        /*margin-top: 46px;*/
    }

    body {
        background-color: #F3F3F3;
    }
</style>
